<template lang="pug">
#relatorio-totalizadores
    .totalizadores
        BlocoInformacaoSkeleton(:carregando='loading')
            BlocoInformacao(
                v-for='item in totalizadores',
                :key='item.id',
                :titulo='item.titulo',
                :numero='item.numero',
            )
                template(slot='icone')
                    i.mdi.mdi-chart-bar
        
</template>

<script>
import BlocoInformacao from '@/modules/relatorio-exportacao/components/BlocoInformacao.vue';
import BlocoInformacaoSkeleton from '@/modules/relatorio-exportacao/components/BlocoInformacaoSkeleton.vue';

export default {
    name: 'RelatorioTotalizadores',
    components: {
        BlocoInformacao,
        BlocoInformacaoSkeleton
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        };
    },
    computed: {
        totalizadores() {
            const itemsAvailable = [
                'totalRegistros',
                'totalContratos',
                'totalContratosDiretos',
                'totalContratosIndiretos',
                'totalCars'
            ];
            const items = this.items.map(item => ({
                id: item.id,
                titulo: this.$t(`relatorioExportacao.totalizadores.${item.id}`),
                numero: item.numero
            }));

            return items.filter(item => itemsAvailable.includes(item.id));
        }
    },
    methods: {

    }
};
</script>

<style lang="scss">
#relatorio-totalizadores {
    .totalizadores .el-skeleton {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        width: 100%;
        flex-wrap: wrap;
        #bloco-informacao {
            cursor: pointer;
        }

        .text-with {
            .bloco-informacao__interno-texto {
                width: 100%;
                max-width: 150px !important;
                @media only screen and (min-width: 1080px) {
                    max-width: 210px !important;
                }
            }
        }
        & > div {
            width: 100% !important;
        }
    }
    
}
</style>
